var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxStoreAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-store-alt",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.3334 9.16663C40.3334 6.13429 37.8657 3.66663 34.8334 3.66663H9.16675C6.13441 3.66663 3.66675 6.13429 3.66675 9.16663V14.3568C3.66675 16.2873 4.36708 18.0418 5.50008 19.3911V34.8333C5.50008 36.8555 7.14458 38.5 9.16675 38.5H34.8334C36.8556 38.5 38.5001 36.8555 38.5001 34.8333V19.3893C39.6331 18.0418 40.3334 16.2873 40.3334 14.355V9.16663ZM36.6667 9.16663V14.3568C36.6667 16.4468 35.1102 18.2288 33.1999 18.3296L33.0001 18.3333C30.9779 18.3333 29.3334 16.6888 29.3334 14.6666V7.33329H34.8334C35.8454 7.33329 36.6667 8.15646 36.6667 9.16663ZM18.3334 7.33329H25.6667V14.6666C25.6667 16.6888 24.0222 18.3333 22.0001 18.3333C19.9779 18.3333 18.3334 16.6888 18.3334 14.6666V7.33329ZM7.33341 9.16663C7.33341 8.15646 8.15475 7.33329 9.16675 7.33329H14.6667V14.6666C14.6667 16.6888 13.0222 18.3333 11.0001 18.3333L10.8002 18.3278C8.88991 18.2288 7.33341 16.4468 7.33341 14.3568V9.16663ZM18.3334 34.8333V29.3333H25.6667V34.8333H18.3334ZM29.3334 34.8333V29.3333C29.3334 27.3111 27.6889 25.6666 25.6667 25.6666H18.3334C16.3112 25.6666 14.6667 27.3111 14.6667 29.3333V34.8333H9.16675V21.7598C9.63241 21.8826 10.1146 21.9633 10.6096 21.989C11.7149 22.0489 12.8194 21.8572 13.8397 21.4281C14.8601 20.9991 15.7698 20.3439 16.5001 19.5121C17.8439 21.0375 19.8129 22 22.0001 22C24.1872 22 26.1562 21.0375 27.5001 19.5121C28.2304 20.3439 29.14 20.9991 30.1604 21.4281C31.1808 21.8572 32.2853 22.0489 33.3906 21.989C33.8874 21.9633 34.3677 21.8826 34.8334 21.7598V34.8333H29.3334Z",
    fill: "url(#paint0_linear_1248_566)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_566",
    x1: 17.0406,
    y1: -3.72724,
    x2: 49.3673,
    y2: 10.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxStoreAlt);
export default __webpack_public_path__ + "static/media/bx-store-alt.00ba6a3ed31553edd8815da9983957b5.svg";
export { ForwardRef as ReactComponent };